//React
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

//External Packages
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faGripLinesVertical } from "@fortawesome/free-solid-svg-icons";

//Internal Components
import {
  CreateDayIconV2,
  ValuesIcon,
  VitIcon,
  VisionIcon,
  IkigaiIcon,
  QuoteIconV2,
  SaveIcon,
} from "../../../components/ui/Icons/Icon";

export default function WeekDock({
  viewType,
  dockLoading,
  meyear,
  load,
  yearid,
  yearList,
  handleSubmit,
  handleMouseState,
  handleRefresh,
}) {
  // Hooks
  const navigate = useNavigate();

  // State
  const [currentWindow, setCurrentWindow] = useState(window.location.href);
  const [viewWidth, setViewWidth] = useState(
    Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0)
  );
  const [showDock, setShowDock] = useState(false);
  const [colorState, setColorState] = useState({
    one: "cls-1-invert",
    two: "cls-2-invert",
  });
  const [dockState, setDockState] = useState("disableddock");

  useEffect(() => {
    if (dockLoading) {
      setDockState("disableddock");
    } else {
      if (viewType === "mobile") {
        setDockState("mobiledock");
      } else {
        setDockState("jordandock");
      }
    }
  }, [dockLoading, viewType]);

  const showDockFunc = () => {
    setShowDock((showDock) => !showDock);
  };

  const [saveTooltip, setSaveTooltip] = useState("");

  const handleTooltipChange = () => {
    setSaveTooltip("Saving...");
    setTimeout(() => {
      setSaveTooltip("Saved");
    }, 1200);
  };

  const handleNav = (meyear) => {
    if (meyear) {
      navigate("/year/create");
    } else {
      navigate(`/year/${yearid}`);
    }
  };

  return (
    <div
      className={
        viewType === "mobile" ? "mobiledock--container" : `dock--container`
      }
    >
      {viewType !== "mobile" && (
        <>
          <a href="/week/create">
            <div
              className={`${dockState} node`}
              data-tooltip="Start a New Week"
            >
              <CreateDayIconV2 />
            </div>
          </a>
          <div className="dock separator">
            <FontAwesomeIcon
              id="separatorIcon"
              className="separator"
              icon={faGripLinesVertical}
            />
          </div>
        </>
      )}

      <div
        className={`${dockState} node`}
        data-tooltip={
          meyear && meyear.name && meyear.birthday
            ? "Me"
            : "Add your name and date of birth to your year map to access it in the dock."
        }
        onClick={() => {
          meyear && meyear.name && meyear.birthday
            ? handleMouseState("me")
            : handleNav(meyear.name);
        }}
      >
        {meyear && meyear.name && meyear.birthday ? (
          <VitIcon />
        ) : (
          <a
            href={
              yearList.years.length > 0 ? `/year/${yearid}` : "/year/create"
            }
          >
            <VitIcon opacity="0.5" />
          </a>
        )}
      </div>
      <div
        className={`${dockState} node`}
        data-tooltip={
          meyear && meyear.values
            ? "My Values"
            : "Add your values in your year map to access them in the dock."
        }
        onClick={() => {
          meyear && meyear.values
            ? handleMouseState("values")
            : handleNav(meyear.values.one);
        }}
      >
        {meyear && meyear.values ? (
          <ValuesIcon />
        ) : (
          <a
            href={
              yearList.years.length > 0 ? `/year/${yearid}` : "/year/create"
            }
          >
            <ValuesIcon opacity="0.5" />
          </a>
        )}
      </div>
      <div
        className={`${dockState} node`}
        data-tooltip={
          meyear && meyear.vision
            ? "My Vision"
            : "Add your vision to your year map to access it through the dock."
        }
        onClick={() => {
          meyear && meyear.vision
            ? handleMouseState("vision")
            : handleNav(meyear.vision.one);
        }}
      >
        {meyear && meyear.vision ? (
          <VisionIcon />
        ) : (
          <a
            href={
              yearList.years.length > 0 ? `/year/${yearid}` : "/year/create"
            }
          >
            <VisionIcon opacity="0.5" />
          </a>
        )}
      </div>
      <div
        className={`${dockState} node`}
        data-tooltip={
          meyear && meyear.ikigai
            ? "My Ikigai"
            : "Add your ikigai to your year map to access it in the dock"
        }
        onClick={() => {
          meyear && meyear.vision
            ? handleMouseState("ikigai")
            : handleNav(meyear.ikigai);
        }}
      >
        {meyear && meyear.ikigai ? (
          <IkigaiIcon />
        ) : (
          <a
            href={
              yearList.years.length > 0 ? `/year/${yearid}` : "/year/create"
            }
          >
            <IkigaiIcon opacity="0.5" />
          </a>
        )}
      </div>
      <div
        className={`${dockState} node`}
        data-tooltip={
          meyear && meyear.quote
            ? "My Favourite Quote"
            : "Add your favourite quote to your year map to access it in the dock."
        }
        onClick={() => {
          meyear && meyear.quote
            ? handleMouseState("quote")
            : handleNav(meyear.quote);
        }}
      >
        {meyear && meyear.quote ? (
          <QuoteIconV2 />
        ) : (
          <a
            href={
              yearList.years.length > 0 ? `/year/${yearid}` : "/year/create"
            }
          >
            <QuoteIconV2 opacity="0.5" />
          </a>
        )}
      </div>
      {/* {viewType !== "mobile" && (
        <>
          <div
            className={`${dockState} node`}
            data-tooltip="Click for Tutorial"
          >
            <QuestionIcon />
          </div>
          <div
            id="refresh"
            className={`${dockState} node ${load}`}
            data-tooltip={load === "success" ? saveTooltip : "Refresh"}
            onClick={() => {
              handleRefresh();
            }}
          >
            <FontAwesomeIcon
              icon={faRotateRight}
              size="2x"
              style={{ color: "#004a22" }}
            />
          </div>
          <div className="dock separator">
            <FontAwesomeIcon
              id="separatorIcon"
              className="separator"
              icon={faGripLinesVertical}
            />
          </div>
        </>
      )} */}
      <div
        id="start"
        className={`${dockState} node ${load}`}
        data-tooltip={load === "success" ? saveTooltip : "Click to Save"}
        onClick={() => {
          handleSubmit();
          handleTooltipChange();
        }}
      >
        <SaveIcon load={load} />
      </div>
    </div>
  );
}
